export const BELL_ICON_ROUTES: string[] = [
  'Crosstab',
  'BrandAnalysis',
  'AdAnalysis',
  'alert-management',
  'custom-snapshot-output',
  'outputview',
  'chart-output',
  'landing'
];

export function shouldShowBellIcon(url: string): boolean {
  const cleanUrl = url.split('?')[0]; 
  return BELL_ICON_ROUTES.some(route =>
    cleanUrl.toLowerCase().includes(route.toLowerCase())
  );
}